import React from "react";
import {
  TextArea,
  NumericTextBox,
  Input,
  Checkbox,
} from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";
import MattersCombobox from "../Postings/MattersComboBox";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import MatterAccount from "../MatterLedger/MatterAccount";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { ComboBoxComponent } from "./ChitRequestComponents";
import styles from "./ChitRequest.module.scss";

const MatterDetails = ({ matter, clear }) => {
  if (!matter) return null;
  const branchText = clear ? "" : matter?.branch ?? "";
  const detailsText = clear ? "" : matter?.details ?? "";
  const matterRefText = matter?.matterRef ?? "";
  const clientNameText = clear ? "" : matter?.clientName ?? "";
  const lineTwo = [detailsText, matterRefText, clientNameText ? `- ${clientNameText}` : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div>
      <div
        style={{
          color: "gray",
        }}
        className="fs-md fw-semibold"
      >
        {branchText}
      </div>
      <div className="fw-bold">{lineTwo}</div>
    </div>
  );
};

const ChitRequestFormContent = ({
  IS_MODAL,
  IS_UNALLOCATED_CREATE,
  isLoadingChitData,
  handlesubmit,
  postingTypes,
  type,
  handleChange,
  chitRequestId,
  onChangematter,
  canSelectMatterInModal,
  matterref,
  unAllocated,
  matter,
  resolvedMatterProp,
  dateselector,
  onChangedateselect,
  matterBalanceClear,
  list,
  state,
  setstate,
  payee,
  setpayee,
  payer,
  setpayer,
  netamount,
  setnetamount,
  vatvalue,
  calculatevatamount,
  vatsdata,
  filterChange,
  onChangevat,
  vatamount,
  feeearner,
  filterfeeearner,
  feeearnerref,
  onChangefeeearner,
  comboBoxesInfo,
  bankName,
  setBankName,
  sortCode,
  setSortCode,
  accountNumber,
  setAccountNumber,
  details,
  setdetails,
  counselfee,
  setcounselfee,
  resetDocs,
  progress,
  filesData,
  onFileRemove,
  handleUpload,
  setFilesData,
  notes,
  setNotes,
  isRejectedChit,
  rejectionInfo,
  resetfields,
  loading,
  validation_message,
  isChitNetAmountInvalid,
  readOnly = false,
}) => {
  const showUnallocatedFieldErrors = validation_message && IS_UNALLOCATED_CREATE;
  const showFieldErrors = validation_message && !IS_UNALLOCATED_CREATE;

  return (
    <div
      className={`${!IS_MODAL ? "vh-100" : "mx-4 h-100"} ${styles["main-container"]}`}
      style={{ position: "relative" }}
    >
      {isLoadingChitData && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div>Loading Chit Request data...</div>
          </div>
        </div>
      )}
      <div className="bgForm overflow-auto">
        <div
          className="px-5 "
          style={{
            maxHeight: !IS_MODAL ? "calc(100vh - 130px)" : "auto",
            overflow: "auto",
          }}
        >
          <form onSubmit={handlesubmit}>
            <div className={`d-flex ${IS_MODAL ? "mt-2" : "mt-4"}`}>
              <div className="d-flex flex-column me-5">
                <div className="d-flex flex-column">
                  <Label className="label mb-1">Posting Type</Label>
                  <DropDownList
                    className={`mb-1 ${styles["input-styles"]} ${styles["posting-type-dropdown"]}`}
                    style={{
                      border: showFieldErrors && !type ? "1px solid red" : undefined,
                    }}
                    data={postingTypes}
                    textField={"display"}
                    iconClassName="wa"
                    dataItemKey="code"
                    value={type}
                    onChange={handleChange}
                    placeholder="Select Type"
                    disabled={
                      readOnly || (IS_MODAL && Boolean(chitRequestId))
                    }
                  />
                </div>

                <div className="d-flex flex-column mt-1">
                  <Label className="label mb-1">Matter</Label>
                  <MattersCombobox
                    className={`${styles["input-styles"]}`}
                    onChangematter={onChangematter}
                    disabled={readOnly || (IS_MODAL && !canSelectMatterInModal)}
                    error={showFieldErrors && !matterref && !unAllocated}
                    value={matterref ? matter : resolvedMatterProp ?? null}
                  />
                </div>
                <div className="d-flex flex-column mt-1 ">
                  <Label className="label mb-1">Date</Label>
                  <div
                    className={
                      validation_message &&
                      (!dateselector ||
                        (dateselector instanceof Date &&
                          Number.isNaN(dateselector.getTime())))
                        ? "date-invalidator"
                        : undefined
                    }
                    style={{ width: "fit-content" }}
                  >
                    <DatePicker
                      className={`${styles["input-styles"]} px-2`}
                      value={dateselector}
                      width={280}
                      onChange={onChangedateselect}
                      toggleButton={CalenderCustomToggleButton}
                      disabled={readOnly}
                    />
                  </div>
                </div>
              </div>

              <div className="pe-1 d-flex flex-column gap-1 ">
                <div className="">
                  <MatterDetails matter={matter} clear={matterBalanceClear} />
                </div>
                <div className="mt-2 mb-2">
                  <MatterAccount
                    component={"Chit Request"}
                    clear={matterBalanceClear}
                    matterId={matter?.matterId}
                  />
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div className="d-flex mb-2">
                {list.includes("Reference") && (
                  <div className="d-flex flex-column me-3" style={{ minWidth: "360px" }}>
                    <Label className="label mb-1">Reference</Label>
                    <Input
                      className={`${styles["input-styles"]}`}
                      value={state}
                      disabled={readOnly}
                      onChange={(e) => {
                        setstate(e.target.value);
                      }}
                      placeholder={"Add Reference"}
                    />
                  </div>
                )}
                {list.includes("Payee") && (
                  <div className="d-flex flex-column">
                    <Label className="label mb-1">Payee</Label>
                    <Input
                      className={`${styles["input-styles"]}`}
                      style={{
                        border:
                          (showFieldErrors && !payee) ||
                          (showUnallocatedFieldErrors &&
                            list.includes("Payee") &&
                            !String(payee || "").trim())
                            ? "1px solid red"
                            : "",
                      }}
                      value={payee}
                      disabled={readOnly}
                      onChange={(e) => {
                        setpayee(e.target.value);
                      }}
                      placeholder={"Add Payee"}
                    />
                  </div>
                )}
                {list.includes("Payer") && !list.includes("Payee") && (
                  <div className="d-flex flex-column" style={{ flex: "1" }}>
                    <Label className="label mb-1">Payer</Label>
                    <Input
                      value={payer}
                      className={`${styles["input-styles"]}`}
                      style={{
                        border:
                          (showFieldErrors && !payer) ||
                          (showUnallocatedFieldErrors &&
                            !list.includes("Payee") &&
                            list.includes("Payer") &&
                            !String(payer || "").trim())
                            ? "1px solid red"
                            : "",
                      }}
                      disabled={readOnly}
                      onChange={(e) => {
                        setpayer(e.target.value);
                      }}
                      placeholder={"Add Payer"}
                    />
                  </div>
                )}
              </div>

              {list.includes("Payer") && list.includes("Payee") && (
                <div className="d-flex mb-2">
                  <div className="d-flex flex-column me-3" style={{ minWidth: "360px" }}>
                    <Label className="label mb-1">Payer</Label>
                    <Input
                      value={payer}
                      className={`${styles["input-styles"]}`}
                      style={{
                        border: showFieldErrors && !payer ? "1px solid red" : "",
                      }}
                      disabled={readOnly}
                      onChange={(e) => {
                        setpayer(e.target.value);
                      }}
                      placeholder={"Add Payer"}
                    />
                  </div>
                  <div style={{ flex: "1" }}></div>
                </div>
              )}

              {list.includes("NetAmount") && (
                <div className="d-flex mb-2">
                  <div className="d-flex flex-column me-3" style={{ minWidth: "360px" }}>
                    <Label className="label mb-1">Net amount</Label>
                    <NumericTextBox
                      value={netamount}
                      className={`${styles["input-styles"]}`}
                      style={{
                        border:
                          (showFieldErrors &&
                            (netamount === 0 || netamount === "") &&
                            "1px solid red") ||
                          (showUnallocatedFieldErrors &&
                            isChitNetAmountInvalid(netamount) &&
                            "1px solid red"),
                      }}
                      inputStyle={{ textAlign: "right" }}
                      disabled={readOnly}
                      onChange={(e) => {
                        setnetamount(e.target.value);
                        if (vatvalue !== undefined) {
                          calculatevatamount();
                        }
                      }}
                      spinners={false}
                      format="n2"
                      placeholder="0.00"
                    />
                  </div>
                  <div style={{ flex: "1" }}></div>
                </div>
              )}

              {list.includes("VatCode") && (
                <div className="d-flex mb-1">
                  <div className="d-flex flex-column me-3">
                    <Label className="label mb-1">VAT</Label>
                    <ComboBox
                      className={`${styles["small-inputbox"]}`}
                      style={{
                        border:
                          showFieldErrors &&
                          type.code !== "ODR" &&
                          type.code !== "OCR" &&
                          type.code !== "CDR" &&
                          type.code !== "CCR" &&
                          type.code !== "DDR" &&
                          type.code !== "DCR" &&
                          vatvalue === undefined
                            ? "1px solid red"
                            : undefined,
                      }}
                      data={vatsdata}
                      textField={"display"}
                      filterable={true}
                      onFilterChange={filterChange}
                      value={vatvalue}
                      onChange={onChangevat}
                      disabled={readOnly}
                      placeholder={"Code"}
                    />
                  </div>
                  {list.includes("VatAmount") && (
                    <div className="d-flex mb-2">
                      <div className="d-flex flex-column me-3" style={{ minWidth: "360px" }}>
                        <Label className="label mb-1">VAT Amount</Label>
                        <NumericTextBox
                          className={`${styles["small-inputbox"]}`}
                          value={vatamount}
                          readOnly={true}
                          placeholder="0.00"
                          spinners={false}
                          format="n2"
                          inputStyle={{ textAlign: "right" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {list.includes("FeeEarnerRef") && (
                <div className="d-flex mb-3">
                  <div className="d-flex flex-column me-3" style={{ minWidth: "360px" }}>
                    <Label className="label mb-1">Fee Earner</Label>
                    <ComboBox
                      className={`${styles["input-styles"]}`}
                      style={{
                        border: showFieldErrors && !feeearnerref ? "1px solid red" : undefined,
                      }}
                      data={feeearner}
                      iconClassName="wa"
                      textField={`display`}
                      filterable
                      onFilterChange={filterfeeearner}
                      placeholder={"Search Fee Earner"}
                      value={feeearnerref}
                      onChange={onChangefeeearner}
                      disabled={readOnly}
                    />
                  </div>
                  {comboBoxesInfo.some(({ key }) => list?.includes(key)) ||
                  list.includes("BankName") ||
                  (list.includes("BankAccountNo") && list.includes("BankSortCode")) ? (
                    <div className="d-flex">
                      {comboBoxesInfo.some(({ key }) => list?.includes(key)) && (
                        <div className="d-flex flex-column me-3" style={{ width: "360px" }}>
                          {comboBoxesInfo.map(
                            ({
                              key,
                              label,
                              condition,
                              data,
                              onFilterChange,
                              value,
                              onChange,
                              field,
                              placeholder,
                            }) =>
                              list?.includes(key) ? (
                                <div key={key}>
                                  <ComboBoxComponent
                                    label={label}
                                    className={`${styles["input-styles"]}`}
                                    style={{
                                      border: showFieldErrors && condition ? "1px solid red" : "",
                                    }}
                                    data={data}
                                    textField={field || "display"}
                                    filterable={true}
                                    onFilterChange={onFilterChange}
                                    value={value}
                                    onChange={onChange}
                                    placeholder={placeholder}
                                    disabled={readOnly}
                                  />
                                </div>
                              ) : null,
                          )}
                        </div>
                      )}
                      <div className="d-flex flex-column" style={{ flex: "1", marginTop: "-70px" }}>
                        {list.includes("BankName") && (
                          <div className="d-flex flex-column me-3">
                            <Label className="label mb-1">Bank Name</Label>
                            <Input
                              className={`${styles["input-styles"]}`}
                              style={{
                                border: showFieldErrors && !bankName ? "1px solid red" : "",
                              }}
                              value={bankName}
                              disabled={readOnly}
                              onChange={(e) => {
                                setBankName(e.target.value);
                              }}
                              placeholder={"Enter Bank Name"}
                            />
                          </div>
                        )}
                        {list.includes("BankAccountNo") && list.includes("BankSortCode") && (
                          <div className="d-flex mt-2">
                            <div className="d-flex flex-column me-3">
                              <Label className="label mb-1">Sort Code</Label>
                              <Input
                                className={`${styles["small-inputbox"]}`}
                                style={{
                                  border: showFieldErrors && !sortCode ? "1px solid red" : "",
                                }}
                                value={sortCode}
                                disabled={readOnly}
                                onChange={(e) => {
                                  setSortCode(e.target.value);
                                }}
                                placeholder={"Enter Sort Code"}
                              />
                            </div>
                            <div className="d-flex flex-column">
                              <Label className="label mb-1">Account Number</Label>
                              <Input
                                className={`${styles["small-inputbox"]}`}
                                style={{
                                  border: showFieldErrors && !accountNumber ? "1px solid red" : "",
                                }}
                                value={accountNumber}
                                disabled={readOnly}
                                onChange={(e) => {
                                  setAccountNumber(e.target.value);
                                }}
                                placeholder={"Enter Account Number"}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
              )}

              <div className="d-flex">
                <div className="d-flex flex-column me-3" style={{ minWidth: "360px" }}>
                  <Label className="label mb-1">Details</Label>
                  <TextArea
                    value={details}
                    className={`${styles["details-textbox"]}`}
                    style={{
                      border: showFieldErrors && !details ? "1px solid red" : "",
                      height: "80px",
                    }}
                    rows={3}
                    multiple={true}
                    placeholder="Enter Details"
                    disabled={readOnly}
                    onChange={(e) => {
                      setdetails(e.target.value);
                    }}
                  />
                  <div
                    className=" d-flex align-items-start justify-content-between mt-2"
                    style={{ width: "326px" }}
                  >
                    <div className="d-flex">
                      {list.includes("IsCounselFee") && (
                        <div className="d-flex gap-1 align-items-center mt-2">
                          <Checkbox
                            className="me-2"
                            value={counselfee}
                            disabled={readOnly}
                            onChange={(e) => setcounselfee(e.value)}
                          />
                          <Label htmlFor="isCounselFee" className="label mb-0">
                            Counsel Fee
                          </Label>
                        </div>
                      )}
                    </div>
                    <div className="">
                      <DocumentsUpload
                        open={false}
                        value={type}
                        type={"Chit Request"}
                        disabled={readOnly}
                        resetDocs={resetDocs}
                        progress={progress}
                        filesData={filesData}
                        onFileRemove={onFileRemove}
                        onError={() => {
                          const newFiles = filesData.splice(filesData.length, 1);
                          setFilesData([...newFiles]);
                        }}
                        onUpload={handleUpload}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column" style={{ minWidth: "360px" }}>
                  <Label className="label mb-1">Notes</Label>
                  <TextArea
                    value={notes}
                    style={{
                      border: showFieldErrors && !notes ? "1px solid red" : "",
                      height: "80px",
                    }}
                    rows={3}
                    multiple={true}
                    placeholder="Enter Notes"
                    disabled={readOnly}
                    onChange={(e) => {
                      setNotes(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            {isRejectedChit && rejectionInfo && (
              <div className="">
                <div className="text-danger">{rejectionInfo.line1}</div>
                {rejectionInfo.reason ? (
                  <div className="text-primary">{rejectionInfo.reason}</div>
                ) : null}
              </div>
            )}

            {!IS_MODAL && (
              <div className={`my-2 d-flex justify-content-end`}>
                <Button
                  className="common-btn bgBtnSecondary me-3"
                  type="button"
                  onClick={() => {
                    resetfields();
                  }}
                >
                  Cancel
                </Button>
                <SubmitButton
                  id="chit-request-post"
                  className="common-btn"
                  isLoading={loading}
                  disabled={loading || readOnly}
                  type="submit"
                >
                  {chitRequestId ? (isRejectedChit ? "Repost" : "Update") : "Post"}
                </SubmitButton>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChitRequestFormContent;
